import HistoryPanel from "../components/HistoryPanel";

export default function HistoryPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <HistoryPanel />
    </div>
  );
}